import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Requires the user to have chosen a plan (free or pro). Otherwise sends to /choose-plan.
export default function PlanGate({ children }) {
  const { user } = useAuth();
  if (user && !user.plan) return <Navigate to="/choose-plan" replace />;
  return children;
}
